/* ========================================================================
 * FD:          FD
 * Child:       CONTROL
 * Version:     1.0
 * ======================================================================== 
 * Description:
 * manage a hopscotch tour
 * ======================================================================== 
 * 3/2/2017: creation
*/

FD.CONTROL = (function ($, me) {
    'use strict';

    var child = me.CONTROL || {};

    var TOUR_LIST_ELEM = '#TOUR_LIST';
    var SITE_TOUR_ELEM = '#SITE_TOUR';
    var START_TOUR_ELEM = '#START_TOUR';
    var calloutManager;
    var tourItem;
    var tour;


    /* ========================================================================
     *  private vars
     * ========================================================================
    */
    

    //  defaults
    var defaults = { };




    /* ========================================================================
     *  private methods
     * ========================================================================
    */
    

    //  get tour 
    function getTour(stepList) {
        var label = me.getLabel();
        tourItem = me.getTourProgress();
        setTopNavTour(stepList);

        for (var x = 0; x < stepList.length - 1; x++) {
            stepList[x].onCTA = handleOnCTA;
            stepList[x].showCTAButton = true;
            stepList[x].ctaLabel = label["EndTour"];
        }

        tour = {
            id: "hopscotch-tour",
            showPrevButton: true,
            smoothScroll: true,
            onClose: handleClose,
            onEnd: handleEnd,
            steps: stepList,
            i18n: {
                nextBtn: label['Next'],
                doneBtn: label['Done'],
                prevBtn: label['Back']
            },
        };



        //  restart site tour
        $(START_TOUR_ELEM).off().on('click', function () {
            $(SITE_TOUR_ELEM).webuiPopover('hide');

            hopscotch.startTour(tour, 0);

            tourItem.TourStep = 0;
            tourItem.TourCompleted = false;

            var options = {
                url: "/Common/Common/UpdateTourProgress",
                params: {
                    tourItem: tourItem
                },
                callback: afterData
            };

            me.AJAX.setAJAX(options);

            function afterData(data) { }
        });
    }


    // populate the steps in the site tour popover
    function setTopNavTour(stepList) {
        var listHTML = [];

        for (var x = 0; x < stepList.length; x++) {
            listHTML.push("<a class='list-group-item' data-step='" + x + "'>(" + (x + 1) + ") " + stepList[x].title + "</div>");
        }

        $(TOUR_LIST_ELEM).html(listHTML.join(''));

        $(TOUR_LIST_ELEM).find('a').on('click', function (event) {
            event.preventDefault();
            var step = +$(this).data('step');
            $(SITE_TOUR_ELEM).webuiPopover('hide');
            hopscotch.startTour(tour, step);
        });
    }


    // save user's progress when a new step is shown
    function handleOnShow() {
        tourItem.TourStep = hopscotch.getCurrStepNum();
        tourItem.TourCompleted = false;

        var options = {
            url: "/Common/Common/UpdateTourProgress",
            params: {
                tourItem: tourItem
            },
            callback: afterData
        };

        me.AJAX.setAJAX(options);

        function afterData(data) { }
    }


    // enable user to complete the tour early
    function handleOnCTA() {
        tourItem.TourStep = hopscotch.getCurrStepNum();
        tourItem.TourCompleted = true;

        var options = {
            url: "/Common/Common/UpdateTourProgress",
            params: {
                tourItem: tourItem
            },
            callback: afterData
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            hopscotch.endTour();
        }
    }


    function handleClose() {
        $('.site-control li:not([data-alwaysactive])').removeClass('active');
        calloutManager.removeAllCallouts();
        tourItem.TourStep = hopscotch.getCurrStepNum();
        tourItem.TourCompleted = false;

        var options = {
            url: "/Common/Common/UpdateTourProgress",
            params: {
                tourItem: tourItem
            },
            callback: afterData
        };

        me.AJAX.setAJAX(options);

        function afterData(data) { }
    }


    // save tour completion
    function handleEnd() {
        $('.site-control li:not([data-alwaysactive])').removeClass('active');
        if (hopscotch.getState()) {
            tourItem.TourStep = +hopscotch.getState().split(":")[1];
            if (tourItem.TourStep >= 16) tourItem.TourCompleted = true;
        } else {
            tourItem.TourStep = hopscotch.getCurrStepNum();
            tourItem.TourCompleted = true;
        }
        calloutManager.removeAllCallouts();
        $('body').off('click');
        var options = {
            url: "/Common/Common/UpdateTourProgress",
            params: {
                tourItem: tourItem
            },
            callback: afterData
        };

        me.AJAX.setAJAX(options);

        function afterData(data) { }
    }



    /* ========================================================================
     *  public methods
     * ========================================================================
    */


    //  prepare the tour
    child.setTour = function (stepList) {
        if ($(SITE_TOUR_ELEM).length > 0 && stepList && stepList.length > 0) {
            if (!calloutManager) {
                calloutManager = hopscotch.getCalloutManager();
            }
            getTour(stepList);
        } else {
            window.console && console.log("The tour functionality is not currently enabled on this page.");
        }
    }


    // start the tour
    child.startTour = function () {
        if (tourItem &&!tourItem.TourCompleted) {
            $('body').off().on('click', function (e) {
                if (!(e.isTrigger && e.isTrigger > 1) && !($(e.target).hasClass('hopscotch-nav-button'))) {
                    hopscotch.endTour(false);
                }
            })
            hopscotch.startTour(tour, tourItem.TourStep);
        }
    }


    child.getCalloutManager = function() {
        if (!calloutManager) {
            calloutManager = hopscotch.getCalloutManager();
        }
        return calloutManager;
    }

    /* ========================================================================
     *  return
     * ========================================================================
    */
    return child;
}(jQuery, FD));